import API from '../../services/API'

import {USER_ACTION_DELETE_ACCOUNT} from './user-types'
import {AUTH_NAMESPACE, AUTH_ACTION_LOG_OUT} from './auth-types'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {},
    getters: {},
    mutations: {},

    actions: {
        [USER_ACTION_DELETE_ACCOUNT] ({commit, dispatch}, payload) {
            API.deleteUserAccount()
                .then(() => {
                    dispatch(AUTH_NAMESPACE + '/' + AUTH_ACTION_LOG_OUT, {}, {root: true})
                    OAlert.showSuccess('', i18n.t('feedback.accountSucDelete'))
                })
                .catch((error) => {
                    console.log(error.message)
                })
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js